import React from "react";
import { logEvent } from "@Lib/analytics";
import styles from "./index.module.less";
import { g4 } from "../../../../utils/helper";

class ArticleItem extends React.Component {
  io = null;

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.scrollWatch(this.el);
  }

  scrollWatch = (el) => {
    let isFrist = false;
    const { analytics } = this.props.data;
    

    try {
      this.io = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !isFrist) {
            isFrist = true;
            g4 && g4('article_exposure', {
              article_type: analytics.articleType,
              article_id: analytics.articleId,
              element: "影音詳情頁",
              author_id: analytics.authorId,
              sub_article_type: analytics.subArticleType,
              brand_ids: analytics.brandIds,
              kind_ids: analytics.kindIds,
              tag: "其它",
            });
          }
        },
        { threshold: [0.65] }
      );
      if (el) {
        this.io.observe(el);
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { data, category } = this.props;
    return (
      <div
        className={styles["ArticleItem"]}
        onClick={() => {
          logEvent(category, "相關文章", data.title),
          g4('article_click', {
            article_type: data.analytics.articleType,
            article_id: data.analytics.articleId,
            element: "影音詳情頁",
            author_id: data.analytics.authorId,
            sub_article_type: data.analytics.subArticleType,
            brand_ids: data.analytics.brandIds,
            kind_ids: data.analytics.kindIds,
            tag: "其它",
          });
        }}
        ref={(el) => (this.el = el)}
      >
        <a href={data.link} className={styles["item"]}>
          <img src={data.thumb} className={styles["img"]} />
          <h5>{data.title}</h5>
        </a>
      </div>
    );
  }
}

export default ArticleItem;
